import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, ChartDataLabels);

// Keep this OUTSIDE the component
const colors = [
  "#36A2EB",
  "#4BC0C0",
  "#FFCE56",
  "#FF6384",
  "#9966FF",
  "#FF9F40",
  "#2ecc71",
];

function SectorDistribution({ chart_data, setSectorId, setSectorName }) {
  const [label, setLabel] = useState([]);
  const [values, setValues] = useState([]);
  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });

  const [options, setOptions] = useState({});
  const [sectorMapping, setSectorMapping] = useState({});

  useEffect(() => {
    let sector = [];
    let revenue = [];
    let mapping = {};

    const total_amount =
      chart_data?.reduce(
        (sum, item) => sum + Number(item.total_amount || 0),
        0
      ) || 0;

    if (total_amount === 0) {
      setLabel([]);
      setValues([]);
      setSectorMapping({});
      return;
    }

    chart_data?.forEach((item) => {
      const percentage = (
        (Number(item.total_amount || 0) / total_amount) *
        100
      ).toFixed(1);

      if (item.id === 7) {
        sector.push("Healthcare");
        revenue.push(percentage);
        mapping["Healthcare"] = [7];
      } else {
        sector.push(item.industry_name);
        revenue.push(percentage);
        mapping[item.industry_name] = [item.id];
      }
    });

    setLabel(sector);
    setValues(revenue);
    setSectorMapping(mapping);
  }, [chart_data]);

  useEffect(() => {
    if (label.length === 0) {
      setData({
        labels: [],
        datasets: [],
      });
      return;
    }

    setData({
      labels: label,
      datasets: [
        {
          data: values,
          backgroundColor: colors.slice(0, values.length),
          borderWidth: 0,
        },
      ],
    });

    setOptions({
      responsive: true,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 40,
          bottom: 40,
          left: 50,
          right: 40,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          color: "#000",
          anchor: "end",
          align: "end",
          offset: 8,
          formatter: (value) => {
            return value > 1 ? value + "%" : "";
          },
          font: {
            weight: "bold",
            size: 12,
          },
        },
        tooltip: {
          callbacks: {
            label: (context) =>
              `${context.label}: ${context.raw}%`,
          },
        },
      },
      onClick: (evt, elements) => {
        if (!elements.length) return;

        const index = elements[0].index;
        const sectorName = label[index];
        const sectorIds = sectorMapping[sectorName] || [];

        setSectorId(sectorIds);
        setSectorName(sectorName);

        console.log(
          "Clicked region:",
          sectorName,
          "IDs:",
          sectorIds
        );
      },
      onHover: (event, elements) => {
        if (elements.length > 0) {
          event.native.target.style.cursor = "pointer";
        } else {
          event.native.target.style.cursor = "default";
        }
      },
    });
  }, [
    label,
    values,
    sectorMapping,
    setSectorId,
    setSectorName,
  ]);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        alignItems: "center",
      }}
    >
      <div style={{ width: "60%", height: "350px" }}>
        {data?.datasets?.length > 0 && (
          <Pie data={data} options={options} />
        )}
      </div>

      <div style={{ width: "40%", paddingLeft: "20px" }}>
        {label.map((itemLabel, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <div
              style={{
                width: 14,
                height: 14,
                backgroundColor: colors[index],
                marginRight: 10,
                borderRadius: 4,
              }}
            />

            <span style={{ fontSize: "14px" }}>
              {itemLabel} –{" "}
              <strong>{values[index]}%</strong>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SectorDistribution;